$(document).ready(function () {

  var saletag_svg = '<svg {{ shared_attr }} width="20" height="20" viewBox="0 0 350 350" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 197.826C0 192.95 1.93821 188.275 5.38762 184.83L179.459 10.7587C186.348 3.86966 195.692 -0.000356971 205.435 2.46966e-08H334.782C343.187 2.46966e-08 350 6.81304 350 15.2173V144.565C350 154.308 346.13 163.651 339.241 170.541L165.17 344.612C161.725 348.061 157.049 350 152.174 350C147.299 350 142.624 348.061 139.179 344.612L5.38762 210.821C1.93821 207.376 0 202.701 0 197.826ZM304.348 68.4786C304.348 81.085 294.128 91.3046 281.521 91.3046C268.915 91.3046 258.695 81.085 258.695 68.4786C258.695 55.8721 268.915 45.6525 281.521 45.6525C294.128 45.6525 304.348 55.8721 304.348 68.4786Z" fill="currentColor"/></svg>';

  // Add to cart for single product on cart Drawer By Arctic Grey
  $(document).on('click', '.add-to-cart-refresh', function () {

    var id = $(this).data('variant-id');

    $.ajax({
      type: "POST",
      url: '/cart/add.js',
      dataType: "json",
      data: { id: id, 'quantity': 1 },
      error: function (data, textstatus) { },
      success: function (data, textstatus) {

        //$('#custom_cart_text_' + id).html("Added in Cart");
        // set cart drawer responce in html
        cartdrawerSetResponce();
      }
    });
  });

  // remove product from cart
  // This button will decrement the value till 0
  $(document).on('click', '.remove-variant', function (e) {
    e.preventDefault();
    var variant_id = $(this).attr('data-product-id');
    var custom_cart_count = $(".cart-count-number").html();

    var cart_qty = $('.variant_id_' + variant_id).val();
    //        console.log(cart_qty);
    var new_custom_cart_count = parseInt(custom_cart_count) - parseInt(cart_qty);
    //        console.log(new_custom_cart_count);
    $(".cart-count-number").html(new_custom_cart_count);
    // Stop acting like a button

    // Get the field name


    $.post('/cart/update.js',
      "updates[" + variant_id + "]=0"
    ).
      done(function () {
        
        $(".removevariant_" + variant_id).remove();

      }).fail(function () {
        console.log("error");
      })
      .always(function (data) {
        var sub_total = JSON.parse(data);
        sub_total = (sub_total.items_subtotal_price) / 100;
        $(".custom-subtotal").text('$' + parseFloat(sub_total, 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString());


		cartdrawerSetResponce();
      });
    
    //cartdrawerSetResponce();
  });
  
  // Handle swatch form submit for add to cart
  $(document).on('submit','form.swatch-addtocart-form',function(e){
    // code
    e.preventDefault();
    var form_data = $(this).serialize();
    $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data: form_data,
      success: addToCartWithSwatch,
      error: addToCartFail
   });
  });	
  
  // Detect checkout price change for special offer price change for special offer products
  /*
  $("body").on('DOMSubtreeModified', ".saso-cart-item-price", function() {
    	
      if( $(this).find('.discounted_price').text() != ''){
        
        var tr_cart_item = $(this).parents('tr.cart-item');
        
        var $price = $(this).find('.discounted_price').text();
        var gift_price = $price.split('$');
        
        var $oldprice = tr_cart_item.find('.final-price.money.two').text();
        var old_price = $oldprice.split('$');
        
        
        var tr_cart_item_qty = tr_cart_item.find('td.quantity').find('input').val();
        // Strike line to original price for gift product.
        tr_cart_item.find('.final-price.money.two').css('text-decoration','line-through');
        
        
        if( tr_cart_item_qty ){
        	var count_gift_price = gift_price[1] * parseInt(tr_cart_item_qty);
          	var count_old_price = old_price[1] * parseInt(tr_cart_item_qty);
          	
          	// Set new price for this line of gift product
          	tr_cart_item.find('td.total.last').find('.final-price.money').html('$'+count_gift_price.toFixed(2));
          
          	// get cart Total price 
          	var $cart_total = $('.cart-price').find('.money').text();
          	
        	var tempcart_total = $cart_total.split('$');
          	
          	var new_cart_total = tempcart_total[1] - (count_old_price - count_gift_price);
          	
          	$('.cart-price').find('.money').html('$'+new_cart_total.toFixed(2));
          
        }
      }
    
  });
  */
  
});

function revertBtnToSelectSwatch(article){
  
  // Event for swatches hide when click on any other button for choose swatche
  
  var elems = document.querySelectorAll("article.product-list-item ");

  [].forEach.call(elems, function(el) {
    el.classList.remove("active");
    var current_id = el.getAttribute('id');
    
    $('.swatches-container').css('height','0px');  
    
    var frm_btn = el.querySelector('.variant-option-submit');
    
    
    if( frm_btn.classList.contains('add-to-cart-refresh') === false){
      
      	frm_btn.setAttribute("onClick","starAppsDrawer()");
      	
     	var frm_btn_span = frm_btn.querySelector('.label-choose');
      	
      	var btn_text = frm_btn_span.getAttribute('data-initial-text');	
      	var variant_text = frm_btn_span.getAttribute('data-variant-text');
      
      	frm_btn_span.innerHTML = variant_text;
      
      	frm_btn.removeAttribute('disabled');
      
    }
    
  }); 
  
}

function addToCartWithSwatch(productResponce) {      
  //cartupdate();    
  if(productResponce){
    // set cart drawer responce in html
    setTimeout(function () {
    cartdrawerSetResponce();
       }, 1500);
  }
}

function addToCartFail(obj, status) { 
   alert('The product you are trying to add is out of stock.'); 
}

function cartdrawerSetResponce() {
  var saletag_svg = '<svg {{ shared_attr }} width="20" height="20" viewBox="0 0 350 350" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 197.826C0 192.95 1.93821 188.275 5.38762 184.83L179.459 10.7587C186.348 3.86966 195.692 -0.000356971 205.435 2.46966e-08H334.782C343.187 2.46966e-08 350 6.81304 350 15.2173V144.565C350 154.308 346.13 163.651 339.241 170.541L165.17 344.612C161.725 348.061 157.049 350 152.174 350C147.299 350 142.624 348.061 139.179 344.612L5.38762 210.821C1.93821 207.376 0 202.701 0 197.826ZM304.348 68.4786C304.348 81.085 294.128 91.3046 281.521 91.3046C268.915 91.3046 258.695 81.085 258.695 68.4786C258.695 55.8721 268.915 45.6525 281.521 45.6525C294.128 45.6525 304.348 55.8721 304.348 68.4786Z" fill="currentColor"/></svg>';

  $.getJSON('/cart.js', function (cart) {

    console.log('====== update cart');
        if (typeof window.opWidget !== 'undefined' && typeof window.opWidget.initialWidget === 'function') {
          window.opWidget.initialWidget();
        }

    //$('.refresh_cart_drawer').empty();

    var size = cart.item_count;
    //console.log(cart);
    
    var cart_total_price = cart.total_price;
    
    
    
    $(".cart-count-number").html(parseInt(size));

    var article = '';

    $(cart.items).each(function (index, item) {

      //console.log(item);

      var item_has_discounts = false;
      if (item.line_level_discount_allocations.length > 0) {
        item_has_discounts = true;
      }
      
      
      
      var bundle_id = 0;
      if(item.properties){
        //console.log(item.properties);
        $.each(item.properties, function (key,property) {          
          if( key == '_free'){
            bundle_id = item.id;
            return false;
          }
        });
       }

      article += `<article class="${item.vendor === 'Order Protection' ? 'op-hidden' : ''} mini-cart-item removevariant_` + item.id + '" data-variant="' + item.id + '"';
      article += 'data-url="' + item.url + '"';
      article += 'data-title="' + item.handle + '">';

      article += '<figure class="mini-cart-item-image">';
      article += '<a href="' + item.url + '">'
      article += '<img src="' + imgURL(item.featured_image.url , '100x') + '"></a></figure>';

      article += '<div class="mini-cart-item-details">';
      article += '<p class="mini-cart-item-title">';
      article += '<a href="' + item.url + '">' + item.product_title;
      if (item.variant_options != 'Default Title') {
        article += '(' + item.variant_title + ')';
      }
      article += '</p>';

      let itemProp = item.properties;
      if (!$.isEmptyObject(item.properties)) {
        
        $.each(itemProp, function (property) {
          
          // do something with `property`
          
          if (!$.isEmptyObject(property.last)) {
            article += '<p class="mini-cart-item-property">';
            article += '<span class="property-label">' + property.first + '</span>';
            if (property.last('/uploads/') != -1) {
              article += '<a class="property-image" href="' + property.last + '">';
              let last = property.last.split("/").pop();
              article += last + '</a>';
            } else {
              article += '<span class="property-value">' + property.last + '</span>';
            }
            article += '</p>';
          }
        });
      }

      if (item_has_discounts == true) {
        article += '<s class="original-price">';
        article += '<span class="money">' + Shopify.formatMoney(item.original_price, "${{amount}}") + '</span>';
        article += '</s>';
      }

      if(bundle_id == 0){
      article += '<span class="cart-item-price money" data-cart-item-subtotal>';
      article += '<span class="saso-cart-item-price" data-key="' + item.key + '"></span>';
      article += '</span>';
      }

      article += '<p class="mini-cart-item-price">';
      article += '<span class="final-price money "><s>' + Shopify.formatMoney(item.final_price, "${{amount}}") + '</s></span>';
      article += '<span class="final-price money two">' + Shopify.formatMoney(item.final_price, "${{amount}}") + '</span>';
      article += '</p>';

      // unit price logic not applyed from mini-cart

      article += '<div class="quantity">';
      if(bundle_id == 0){
      article += '<div class="qtydiv">';
      article += '<div class="qtybox">';
      article += '<span class="btnqty qtyminus icon icon-minus" data-unit-price="' + Shopify.formatMoney(item.final_price, "${{amount}}") + '" data-product-id="' + item.variant_id + '" >-</span>';
      article += '<input type="text" id="updates_' + item.key + '" name="quantity" value="' + item.quantity + '" data-product-id="' + item.product_id + '" data-quantity-key="' + item.key + '"';
      article += 'class="quantity-selector qty_custom_' + item.variant_id + ' quantity-input variant_id_' + item.variant_id + '" readonly="">';
      article += '<span class="btnqty qtyplus icon icon-plus" data-unit-price="' + Shopify.formatMoney(item.final_price, "${{amount}}") + '" data-product-id="' + item.variant_id + '">+</span>';
      article += '</div>';
      article += '</div>';
      } else {
      article += '<p class="mini-cart-item-quantity">Qty: <span>1</span></p>';
      }

      article += '<a href="#" class="remove remove-variant" data-product-id="' + item.variant_id + '" data-remove-item="' + item.key + '">Remove</a>';

      article += '</div>';
      if (item_has_discounts == true) {
        if (!$.isEmptyObject(item.line_level_discount_allocations)) {
          article += '<ul class="cart-item-discounts">';

          $.each(item.line_level_discount_allocations, function (key,discount_allocation) {
            article += saletag_svg;
            if (!$.isEmptyObject(discount_allocation.discount_application.title)) {
            	article += discount_allocation.discount_application.title;
            }
            article += '(-<span class="money">' + Shopify.formatMoney(discount_allocation.amount, "${{amount}}") + '</span>)';
          });

          article += '<ul>';
        }

      }

      article += '</div>';




      article += '</article>';

    });
    
    // Add cart total price to checkout button for cart drawer
    $('.custom-subtotal').html(Shopify.formatMoney(cart_total_price, "${{amount}}") );

    //console.log(article);

    $(".refresh_cart_drawer").html(article);
      
    $.get("https://ipinfo.io", function(response) {
      console.log(response.city, response.country);
      let total_width;
      let width = cart_total_price;
      if(response.country == "US") {
        total_width = 5000;
      }
      else if(response.country == "CA") {
        total_width = 6500;
      }
      else {
        total_width = 7500;
      }
      console.log("qqqqqqqqqqqqqqqqqqqq", total_width);
      let progress = width / total_width * 100;
      if(progress >= 100) {
        progress = 100;
        $('.js-shipping-threshold-not-yet-met').addClass('hide');
        $('.js-shipping-threshold-met').removeClass('hide');
      }
      else {
        $('.js-shipping-threshold-not-yet-met').removeClass('hide');
        $('.js-shipping-threshold-met').addClass('hide');
      }
      $('.js-progress-bar').css('width', `${progress}%`);
      $('.js-amount-needed-for-shipping').text((total_width - width) / 100);
    }, "jsonp");

  });

  // Open Cart Drawer
  Open_mini_cart();

}

function Open_mini_cart() {
  $('body').addClass('overlay');
  $('.mini-cart').addClass('left');
  $('.mini-cart').show('800');
}

// alternatively, if you don't want to use a polyfil
function imgURL(src, size) {
  // remove any current image size then add the new image size
  return src
    .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
    .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function(match) {
      return '_'+size+match;
    })
  ;
}

$(document).ready(function () {
  $('body').on('click', '.vario-variant', function () {
  var variant_id = $(this).attr('data-product-id');
    //alert(variant_id);
  });
  // $('body').on('click', '.mini-cart-item .qtyminus, .mini-cart-item .qtyplus, .remove.remove-variant, .shopify-product-form .add-to-cart', function () {
  //  setTimeout(function () {
  //     cartupdate()
  //       }, 1500);
  // });

  $.get("https://ipinfo.io", function(response) {
    console.log(response.city, response.country);
    let total_width;
    let width = $('.js-progress-bar').data('subtotal');
    if(response.country == "US") {
      total_width = 5000;
    }
    else if(response.country == "CA") {
      total_width = 6500;
    }
    else {
      total_width = 7500;
    }
    console.log("qqqqqqqqqqqqqqqqqqqq", total_width);
    let progress = width / total_width * 100;
    if(progress >= 100) {
      progress = 100;
      $('.js-shipping-threshold-not-yet-met').addClass('hide');
      $('.js-shipping-threshold-met').removeClass('hide');
    }
    else {
      $('.js-shipping-threshold-not-yet-met').removeClass('hide');
      $('.js-shipping-threshold-met').addClass('hide');
    }
    $('.js-progress-bar').css('width', `${progress}%`);
    $('.js-amount-needed-for-shipping').text((total_width - width) / 100);
  }, "jsonp");

});

// function cartupdate(){
//     $.getJSON('/cart.js', function(data){
//      var items = data.items;
       
//      var total = data.total_price;
//      var free_gift_over_price_40 = 7500;  
//     var variant_id = "42493320364210";
//     var currentVarId;
//      var quantity;
//       var producthandle;
//        var isgwpprod;
//      var isProduct = false;
//       var producttag;
//          console.log(data);
//         items.forEach(function(e,i,a){
//          currentVarId = e.variant_id;
//           producthandle = e.handle;
//           if(currentVarId == variant_id) {
//            isProduct = true;
//            quantity = e.quantity;
          
//            if(e.properties && e.properties.is_gwp){
//              isgwpprod = true;
//            }
//          }
//          if(e.handle == 'ageless-glow-serum-bb-cream-spf-40' || e.handle == 'perfect-glow-bb-cream-spf-30' || e.handle == 'youth-glow-vitamin-c-cc-cream-spf-50' || e.handle == 'radiant-glow-illuminating-bb-cream-spf-30' || e.handle == 'holiday-perfect-glow-kit' || e.handle == 'the-perfect-pair' || e.handle == 'complexion-perfection-bundle' || e.handle == 'holiday-ageless-glow-kit'){
//            producttag = true;
//          }
              
//        });
//  if(producttag)
//                          {
//                              if(!isgwpprod) {
//                             $.ajax({
//                               type: 'POST',
//                               url: '/cart/add.js',
//                               data: {
//                                  quantity: 1,
//                                  id: variant_id,
//                                 properties: {
//                                   is_gwp: true
//                                 }
//                               },
//                               dataType: 'json',
//                               success: function (response) {
//                                 cartdrawerSetResponce();
//                                 },
//                             });
//                           }    
//                          }
//                            else{
//                             if(isProduct && isgwpprod) {
//                               $.ajax({
//                               type: 'POST',
//                               url: '/cart/change.js',
//                               data: {
//                                  quantity: 0,
//                                  id: variant_id,
//                                 properties: {
//                                   is_gwp: true
//                                 }
//                               },
//                               dataType: 'json',
//                               success: function (response) {
//                                 cartdrawerSetResponce();
//                                 },
//                             });
//                             }
//                            }
       
  
// });
//   }
